import { useState, useEffect, useMemo } from 'react'
import { Tasks } from 'components/common/Tasks'
import { ScheduleTaskModal } from 'components/common/modals/ScheduleTaskModal'
import { useDispatch, useSelector } from 'react-redux'
import * as ACT from '../actions'
import { useParams } from 'react-router-dom'
import { toUsersSelect } from 'components/Users/serializers'
import { dealTasksMapper } from 'utils/serializers'
import { makeGetRequest } from 'utils/api'

const DealTasksContainer = () => {
  const [isScheduleTaskModalVisible, setIsScheduleTaskModalOpen] = useState(false)
  const [editTasksModal, setEditTasksModal] = useState(false)
  const [task, setTask] = useState(null)
  const dispatch = useDispatch()
  const tasks = useSelector(state => state.deal.tasks)
  const users = useSelector(state => state.users)
  const { id } = useParams()
  const [dealSummary, setDealSummary] = useState({})

  const dealTasks = useMemo(
    () => dealTasksMapper(tasks, dealSummary.name),
    [dealSummary.name, tasks]
  )

  useEffect(() => {
    dispatch({ type: ACT.DEAL_TASKS_FETCH_REQUESTED, payload: { id } })
  }, [dispatch, id])

  useEffect(() => {
    if (!users?.users?.length) {
      dispatch({
        type: ACT.USERS_FETCH_REQUESTED
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    ;(async () => {
      const summary = await makeGetRequest(`/v1/deals/proposals-summary/${id}`)
      setDealSummary(summary)
    })()
  }, [id, setDealSummary])

  const toggleScheduleTaskModal = (params = {}) => {
    setIsScheduleTaskModalOpen(!isScheduleTaskModalVisible)
    setEditTasksModal(!!params.edit)
    setTask(params.task || null)
  }

  const createTask = task => {
    dispatch({
      type: ACT.CREATE_DEAL_TASK_REQUESTED,
      payload: {
        task,
        dealId: id
      }
    })
  }

  const updateTask = task => {
    dispatch({
      type: ACT.UPDATE_DEAL_TASK_REQUESTED,
      payload: {
        task
      }
    })
  }

  const markTaskAsDone = id => {
    dispatch({
      type: ACT.DEAL_TASK_MARK_COMPLETED_REQUESTED,
      payload: {
        id
      }
    })
  }

  const markTaskAsNotDone = id => {
    dispatch({
      type: ACT.DEAL_TASK_MARK_NOT_COMPLETED_REQUESTED,
      payload: {
        id
      }
    })
  }

  const deleteTask = task => {
    dispatch({
      type: ACT.DELETE_DEAL_TASK_REQUESTED,
      payload: {
        task
      }
    })
  }

  return (
    <>
      <Tasks
        showScheduleTaskModal={toggleScheduleTaskModal}
        tasks={dealTasks}
        markAsDone={markTaskAsDone}
        markAsNotDone={markTaskAsNotDone}
      />
      {isScheduleTaskModalVisible && (
        <ScheduleTaskModal
          showScheduleTaskModal={isScheduleTaskModalVisible}
          toggleScheduleTaskModal={toggleScheduleTaskModal}
          createTask={createTask}
          updateTask={updateTask}
          users={toUsersSelect(users.users)}
          deal={dealSummary}
          edit={editTasksModal}
          selectedTask={task}
          markAsDone={markTaskAsDone}
          markAsNotDone={markTaskAsNotDone}
          deleteTask={deleteTask}
          proposals={dealSummary.proposals}
        />
      )}
    </>
  )
}

export default DealTasksContainer
